import React from "react";

// Styles //
import "./videoCard.scss";

interface VideoCardProps {
    title?: string;
    intro?: { json: any };
    videoUrl: string;
}

const VideoCard = ({ title, intro, videoUrl }: VideoCardProps) => {
    return (
        <div className="m-video-card">
            <div className="m-video-card__inner">
                <div className="m-video-card__inner__video">
                    <iframe
                        className="video"
                        src={videoUrl}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                </div>
                <div className="m-video-card__inner__text">
                    <h2>{title}</h2>
                    <p>{intro}</p>
                </div>
            </div>
        </div>
    );
};

export default VideoCard;
